import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { H4 } from 'components/Typography';

import { colorAccent, mediaQueryMobileMin } from 'styles';

export const Title = styled(H4)`
  margin-bottom: 16px;
`;

export const ItemsList = styled.div``;

export const Item = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  border-top: 1px solid #e5eaf3;

  @media all and ${mediaQueryMobileMin} {
    flex-direction: row;
    align-items: center;
  }
`;

export const SourceLink = styled(Link)`
  flex: 1 1 50%;
  line-height: 16px;
  padding-right: 16px;
  margin-bottom: 8px;
  color: ${colorAccent};

  @media all and ${mediaQueryMobileMin} {
    margin-bottom: 0;
  }
`;

export const TargetLabel = styled.strong`
  flex: 1 1 50%;
  font-size: 16px;
  line-height: 16px;
`;
